var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.307 13 2.25 6H1.443l2.25-6h12.614z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1c1.38 0 2.628.566 3.532 1.479A5.075 5.075 0 0 1 15 6.06c0 1.956-1.745 4.754-5 8.44-3.255-3.686-5-6.484-5-8.44 0-1.399.56-2.666 1.468-3.582A4.955 4.955 0 0 1 10 1z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 10,
    cy: 6,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapWhite);
export default __webpack_public_path__ + "static/media/map-white.76b9910ca4d1a414b1175d24712d9066.svg";
export { ForwardRef as ReactComponent };